import { CommonState } from '@/store/modules/common/store';
import { ImmocheckValuationState } from '@/store/modules/immocheckValuation/types';
import { type SplitState } from '@smg-real-estate/vue-experiments';

export const enum StoreNamespaces {
  Common = 'common',
  ImmocheckValuation = 'immocheckValuation',
  Split = 'split',
}

export const FunnelStorageKey = 'ubs-immocheck_funnel';
export const FunnelStorageBackupKey = 'ubs-immocheck_funnel-backup';

export interface AppState {
  [StoreNamespaces.Common]: CommonState;
  [StoreNamespaces.ImmocheckValuation]: ImmocheckValuationState;
  [StoreNamespaces.Split]: SplitState;
}
